<span class="tag tag-{{color}}">
  <ng-content></ng-content>
</span>
